module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "head_images",
      "label": "会议头图",
      "width": "170",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.head_images == null ? '未上传' : scope.row.head_images,
            "width": "250px"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enterprise_name",
      "label": "主办方",
      "width": "200",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "会议主题",
      "width": "180",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "会议类型",
      "width": "150",
      "prop": "type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "begin_start_time",
      "label": "开始时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "begin_end_time",
      "label": "结束时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registrationnum",
      "label": "报名人数",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusmark",
      "label": "会议状态",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "states",
      "label": "是否推荐",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择",
            "size": "mini"
          },
          on: {
            "change": function($event) {
              return _vm.recommend(scope.row)
            }
          },
          model: {
            value: (scope.row.states),
            callback: function($$v) {
              _vm.$set(scope.row, "states", $$v)
            },
            expression: "scope.row.states"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-14125f53!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/widghtMeeting.vue
// module id = 444
// module chunks = 11